import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS } from 'chart.js/auto';

export const YearlyEarningsChart = ({ data }) => {
  // Generate last 10 years including current year
  const currentYear = new Date().getFullYear();
  const allYears = Array.from({ length: 10 }, (_, i) => `${currentYear - 9 + i}`);

  // Create earnings map for quick lookup
  const earningsMap = new Map(data.map(item => [item.year.trim(), item.totalAmount]));

  // Chart data configuration
  const chartData = {
    labels: allYears,
    datasets: [{
      label: 'Yearly Earnings',
      data: allYears.map(year => earningsMap.get(year) || 0),
      backgroundColor: 'rgba(255, 152, 0, 0.2)', // Orange with transparency
      borderColor: '#FF9800', // Solid orange border
      borderWidth: 2,
      hoverBackgroundColor: '#FF9800' // Solid orange on hover
    }]
  };

  // Chart options configuration
  const options = {
    plugins: {
      legend: {
        display: true,
        position: 'bottom'
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.dataset.label || '';
            const value = context.raw || 0;
            return `${label}: $${value.toFixed(2)}`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => `$${value}`
        }
      },
      x: {
        grid: {
          display: false // Remove vertical grid lines
        }
      }
    },
    maintainAspectRatio: false // Allow the chart to respect the container height
  };

  return (
    <div style={{ height: '400px', width: '100%' }}> {/* Fixed height container */}
      <Bar data={chartData} options={options} />
    </div>
  );
};